import { IPredefinedTheme } from "../../Themes";
import img1 from "./screenshot.png";

export const Theme: IPredefinedTheme = {
  name: "Mayukai Dark",
  description: "Mayukai Dark-esque",
  credit: "Festive Noire",
  reference: "https://discord.com/channels/415207508303544321/921991895230611466/922037502334889994",
  screenshot: img1,
  colors: {
    primarylight: "#DDDFC5",
    primary: "#CDCFB6",
    primarydark: "#9D9F8C",
    successlight: "#00EF00",
    success: "#00A500",
    successdark: "#007A00",
    errorlight: "#F92672",
    error: "#CA1C5C",
    errordark: "#90274A",
    secondarylight: "#AAA",
    secondary: "#888",
    secondarydark: "#666",
    warninglight: "#D3D300",
    warning: "#cc0",
    warningdark: "#990",
    infolight: "#69f",
    info: "#36c",
    infodark: "#039",
    welllight: "#444",
    well: "#00010A",
    white: "#fff",
    black: "#020509",
    hp: "#dd3434",
    money: "#ffd700",
    hack: "#8CCF27",
    combat: "#faffdf",
    cha: "#a671d1",
    int: "#6495ed",
    rep: "#faffdf",
    disabled: "#66cfbc",
    backgroundprimary: "#080C11",
    backgroundsecondary: "#03080F",
    button: "#00010A",
  },
};
